module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayclear@3-11c8ffa90ae66753af03033f0206d42e.png";